const situations = [
    {id:'started', 'label':'Iniciado'},
    {id:'approved', 'label':'Agendado'},
    {id:'missed', 'label':'Não realizado'},
    {id:'canceled', 'label':'Cancelado'},
    {id:'done', 'label':'Realizado'},
    {id:'noshow', 'label':'Cancelado em menos de 24 horas'}
];
export default situations;
